// extracted by mini-css-extract-plugin
export default {"voteC-icon-button":"voteComponent_voteC-icon-button__cq8cj"};